

import React, { Component } from 'react';
import { Header, Table, Popup, Grid } from 'semantic-ui-react';
import Images from '../../../../../../config/images'
import { isEmpty, isNull, isUndefined } from "lodash";
class PrintDaily extends Component {
    constructor() {
        super();
        this.state = {
            values: [],
            activeIndex: -1,
            disabled: {},
            loading: false,
        }
    }

    formatTotal = (duty, tax, add, cvd, other) => {
        let formatDuty = (parseFloat(duty) / 100)
        let formatTax = (parseFloat(tax) / 100)
        let formatAdd = (parseFloat(add) / 100)
        let formatCvd = (parseFloat(cvd) / 100)
        let formatOther = parseFloat(other)
        let total = parseFloat(formatDuty + formatTax + formatAdd + formatCvd + formatOther).toFixed(2)
        return (total)
    }

    calculateOtherFees = (array) => {
        let total = 0;
        if(array) {
            for (let i = 0; i < array.length; i++) {
                total = total + parseFloat(array[i].value)    
            }
        }
        total = parseFloat(total / 100).toFixed(2)
        return total;
    }

    componentWillMount = () => {
        const { statementEntries } = this.props.cbpDailyData
        if (statementEntries) {
            let totals = []
            for (let i = 0; i < statementEntries.length; i++) {
                let total = this.calculateOtherFees(statementEntries[i].fees)
                totals.push(total)
            }
            
            this.setState({ otherFees: totals })
        }
    }

    handleClick = () => {
        const { cbpDailyIndex } = this.props
        const { activeIndex } = this.state
        const newIndex = activeIndex === cbpDailyIndex ? -1 : cbpDailyIndex

        this.setState({ activeIndex: newIndex })
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleRemove = (e, { name, value }) => {
        if (value === 'remove') {
            this.setState({ [name]: true })
        }
    }

    formatPrintDate = (date) => {
        return date.split(" ", 1)
    }

    formatMoney = (num) => {
        let value = num && !isEmpty(num) && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        if (value === 'NaN') {
          value='0.00'
        }
        return value;
    }

    render() {

        const { otherFees } = this.state

        const { cbpDailyData, pun } = this.props


        // {activeIndex === 0 ? <Icon name='minus'/> + 'COLLAPSE' : 'EXPAND'}

        return (
            <center>
                <div className='invoicePrint'>
                    {/* <div className='printHeader'>
                        <img style={{ width: '150px' }} src={Images.newknlogo} />
                    </div> */}
                    <div className='cbpPaymentSectionHeaderDiv'>
                        <div className='headerSectionFourPrint'>
                            <Header className='cbpHeaderText top' as='h5'>STATEMENT NUMBER</Header>
                            <Header className='cbpHeaderText' as='h4'>{cbpDailyData.statementNumber}</Header>
                        </div>
                        {/* {pun && <div className='headerSectionFourPrint'>
                            <Header className='cbpHeaderText top' as='h5'>PUN</Header>
                            <Header className='cbpHeaderText' as='h4'>{pun}</Header>
                        </div>} */}
                        <div className='headerSectionFourPrint'>
                            <Header className='cbpHeaderText top' as='h5'>PRINT DATE</Header>
                            <Header className='cbpHeaderText' as='h4'>
                                {this.formatPrintDate(cbpDailyData.preliminaryStatementPrintDate || 'N/A')}
                            </Header>
                        </div>
                        <div className='headerSectionAmountPrint'>
                            <Header className='cbpHeaderText top' as='h5'>AUTHORIZATION AMOUNT</Header>
                            <Header className='cbpHeaderText' as='h4'>
                                ${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}
                            </Header>
                        </div>
                        <div className='headerSectionPayer' style={{ top: '20px !important' }}>
                            <Header className='cbpHeaderText top' as='h5'>ACH PAYER</Header>
                            <Header className='cbpHeaderText' as='h4'>{cbpDailyData.achPayer}</Header>
                        </div>
                        <div className='cbpDivider'></div>
                        <div className='headerSectionThreePrint'>
                            <Header className='cbpHeaderText top' as='h5'>PORT OF ENTRY</Header>
                            <Header className='cbpHeaderText' as='h4'>{cbpDailyData.processingPort}</Header>
                        </div>
                    </div>
                    {/* </Accordion.Title>
                    <Accordion.Content active={activeIndex === cbpDailyIndex} > */}
                    <Table basic='very' selectable>
                        <Table.Header>
                            <Table.Row>
                                {/* <Table.HeaderCell>SHIPMENT ID</Table.HeaderCell> */}
                                <Table.HeaderCell>ENTRY #</Table.HeaderCell>
                                <Table.HeaderCell>IMPORTER</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>DUTIES</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>TAXES</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>ADD</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>CVD</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>OTHER FEES</Table.HeaderCell>
                                <Table.HeaderCell textAlign='right'>TOTAL</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => (
                                <Table.Row key={i} style={{ cursor: 'pointer' }} onClick={this.props.open} disabled={this.state.i}>
                                    {/* <Table.Cell>{item.shipmentId}</Table.Cell> */}
                                    <Table.Cell>{cbpDailyData.filerCode + '-' + item.entryNumber}</Table.Cell>
                                    <Table.Cell>{item.importerRecordNumber}</Table.Cell>
                                    <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.dutyAmount) / 100).toFixed(2))}</Table.Cell>
                                    <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.taxAmount) / 100).toFixed(2))}</Table.Cell>
                                    <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.ADD) / 100).toFixed(2))}</Table.Cell>
                                    <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.CVD) / 100).toFixed(2))}</Table.Cell>
                                    <Popup
                                        size='tiny'
                                        trigger={
                                        <Table.Cell textAlign='right'>
                                            {/* {!isNull(otherFees[i]) && !isUndefined(otherFees[i])  ?`$ ${this.formatMoney(otherFees[i])}` : "$0.00"  }   */}
                                            {!isNull(item.feesTotal) && !isUndefined(item.feesTotal) ? `$${(parseFloat(item.feesTotal) / 100).toFixed(2)}` : "$0.00"}
                                        </Table.Cell>}
                                        header='OTHER FEES'
                                        on={['hover', 'click']}
                                    >
                                        <center><p className='feePopupHeader'>OTHER FEES</p></center>
                                        <br />
                                        <Grid columns={2}>
                                            {item.fees && item.fees.map((fee, i) => (
                                                <Grid.Row key={i}>
                                                    <Grid.Column style={{ width: '70%' }}>
                                                        <p className='cbpOtherFeeLabel'>
                                                            {fee.key}
                                                        </p>
                                                    </Grid.Column>
                                                    <Grid.Column style={{ width: '20%' }}>
                                                        <p className='cbpOtherFeeValue'>${this.formatMoney(parseFloat(fee.value / 100).toFixed(2))}</p>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            ))}
                                        </Grid>

                                    </Popup>
                                    <Table.Cell textAlign='right'>${this.formatMoney(this.formatTotal(item.dutyAmount, item.taxAmount, item.ADD, item.CVD, (parseFloat(item.feesTotal) / 100).toFixed(2) ))}</Table.Cell>
                                </Table.Row>
                            )) : null}
                        </Table.Body>
                    </Table>
                    <br /><br /><br />
                    <div className="cbpPaymentButtonRow">
                        <div className='buttonRowTextDiv'>
                            <p className='buttonRowTextPrint buttonRowLabel'>TOTAL</p>
                            <p className='buttonRowTextPrint buttonRowTotal'>${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}</p>
                        </div>
                    </div>
                </div>
            </center>
        )
    }
}

export default PrintDaily;